exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--page__3I7VT{width:50%}.styles--visibleIcon__3CnYD{margin:5px 13px 0 0;cursor:pointer}@media screen and (max-width: 767px){.styles--visibleIcon__3CnYD{margin-right:5px}}.styles--hidden__3H0K9{display:none}.styles--removeComment__Ezd3O{margin-top:12px}\n", ""]);

// exports
exports.locals = {
	"page": "styles--page__3I7VT",
	"visibleIcon": "styles--visibleIcon__3CnYD",
	"hidden": "styles--hidden__3H0K9",
	"removeComment": "styles--removeComment__Ezd3O"
};